import { z } from 'zod'

export const usePhoneValidationSchema = () =>
  z
    .string({ required_error: useValidationMessage('requiredFieldPhone') })
    .min(1, useValidationMessage('requiredFieldPhone'))
    .regex(/^\d+$/, { message: useValidationMessage('digitsOnly') })
    .length(9, { message: useValidationMessage('phoneInvalid') })
    .regex(/^[1-9]/, { message: useValidationMessage('phoneOperatorInvalid') })
